import React from "react";

import { QRProps } from "@/contexts/QREditorContext/types";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { Typography } from "@/components/Typography";
import { Link } from "@/components/Link";
import { IconList } from "@/components/IconList";
import { Lazy } from "@/components/Lazy";
import { Video } from "@/components/Video";
import { checkValidURL } from "@/utils/formHelper";

import { useVideoData } from "./hooks";

import "./VideoTemplate.scss";

export const VideoTemplate = (props: QRProps<"video">) => {
  const { data, isInitPreview, videos, handleVideoReady, handleVideoError } = useVideoData(props);

  if (!data) {
    return null;
  }

  const {
    companyName,
    title,
    description,
    buttonText,
    buttonUrl,
    themeColor,
    logoUrl,
    socialNetworks,
  } = data;

  return (
    <PhoneLayout
      page="video"
      dataQA="preview-video-container"
      backgroundColor={themeColor?.backgroundColor}
      isInitPreview={isInitPreview}
      hasIncludeBrowser
    >
      <div className="video-template">
        <Typography
          Tag="p"
          spacing={4}
        ></Typography>
        <Typography
          Tag="p"
          classname="u-bold"
          spacing={4}
        >
          {companyName}
        </Typography>
        <Typography
          Tag="p"
          classname="u-semibold"
          size="l"
          style={{ fontSize: "1.25rem", lineHeight: "1.375rem" }}
          spacing={4}
        >
          {title}
        </Typography>
        <Typography
          Tag="p"
          style={{ lineHeight: "1.125rem", letterSpacing: "-0.2px" }}
          spacing={5}
          size="s"
        >
          {description}
        </Typography>

        {buttonText && (
          <Link
            externalLink
            className="button u-spacing-6 u-flex u-flex--center"
            href={checkValidURL(buttonUrl) || ""}
            style={{ backgroundColor: themeColor?.buttonColor, height: "40px" }}
            prefetch={false}
          >
            <span
              data-testid="button-label"
              className="button__text body-s"
            >
              {buttonText}
            </span>
          </Link>
        )}

        {isInitPreview && (
          <Lazy placeholderClass="video-template__skeleton">
            <img
              src={logoUrl}
              alt="video player"
            />
          </Lazy>
        )}

        {videos?.length > 0 &&
          videos.map((video, index) => (
            <div
              key={video.name}
              className="video-wrapper"
            >
              <Video
                key={video.name}
                url={video.url}
                onReady={(isLoaded) => handleVideoReady(index, isLoaded)}
                onError={(error) => handleVideoError(index, video, error)}
              />
            </div>
          ))}

        {socialNetworks?.length > 0 ? (
          <div className="IconList-wrapper">
            <IconList
              center
              items={socialNetworks}
            />
          </div>
        ) : (
          <div style={{ width: "100%", height: "1px", marginTop: "2.5rem" }}></div>
        )}
      </div>
    </PhoneLayout>
  );
};
